import useHeader from './header';

export default function useCheckout({ router, store }) {
  const { getHeader } = useHeader({ router, store });

  const sendCreateOrderCreateEvent = (orderNumbers) => {
    const body = { orderNumbers };

    return store.$apiBFF.sendPersEvent({ type: 'orders-create', data: { header: getHeader(), body } });
  };

  function sendProductsClearCartEvent(products = []) {
    const body = products.map(({ id, skuId }) => ({ productId: id, skuId }));

    return store.$apiBFF.sendPersEvent({ type: 'cart/products-clear-cart', data: { header: getHeader(), body } });
  }

  const getProductQuantityData = (product) => {
    const products = Object.keys(store.state.cart.products)
      .map((productId) => store.state.cart.products[productId]);

    const formatedProducts = products.map((p) => {
      const models = p.models.map((model) => ({
        id: model.id,
        name: model.name,
        price: {
          discountPrice: model.price.discountPrice,
          discountAmount: model.price.discountAmount,
        },
        skus: model.skus,
      }));

      return {
        id: p.id,
        skuId: p.skuId,
        quantity: p.quantity,
        models,
      };
    });

    return {
      productId: product.id,
      cart: {
        products: formatedProducts,
      },
    };
  };

  const sendProductDecreaseCartQuantity = (product, skuId, quantity) => {
    const body = { ...getProductQuantityData(product), skuId, quantity };

    store.$apiBFF.sendPersEvent({ type: 'cart/products/product-decrease-cart-quantity', data: { header: getHeader(), body } });
  };

  const sendProductIncreaseCartQuantity = (product, skuId, quantity) => {
    const body = { ...getProductQuantityData(product), skuId, quantity };

    store.$apiBFF.sendPersEvent({ type: 'cart/products/product-increase-cart-quantity', data: { header: getHeader(), body } });
  };

  const sendProductRemoveFromCart = (product, skuId, quantity) => {
    const body = { ...getProductQuantityData(product), skuId, quantity };
    store.$apiBFF.sendPersEvent({ type: 'cart/products/product-remove-from-cart', data: { header: getHeader(), body } });
  };

  return {
    sendCreateOrderCreateEvent,
    sendProductsClearCartEvent,
    sendProductDecreaseCartQuantity,
    sendProductIncreaseCartQuantity,
    sendProductRemoveFromCart,
  };
}
